import { Component, OnInit, Input, ChangeDetectorRef, ViewRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { restore } from "./../../../../assets/json/restoreTooltip.en";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { MiscFeatureStateService } from "../../../core-module/services/state/misc-feature-state.service";
@Component({
  standalone: false,
  selector: "app-dtl",
  templateUrl: "./dtl.component.html",
  styleUrls: ["./dtl.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DtlComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  DtlDimStart: LegacyAny;
  DtlDimStartMin: LegacyAny;
  DtlDimStartMax: LegacyAny;
  DtlDimStartOption;
  DtlDimStop: LegacyAny;
  DtlDimStopMax: LegacyAny;
  DtlDimStopMin: LegacyAny;
  DtlOutputPercentage: LegacyAny;
  DtlOutputPercentageMax: LegacyAny;
  DtlOutputPercentageMin: LegacyAny;
  ngModelval: LegacyAny = [];
  DtlDimStopVal: number;
  DtlDimStartVal: number;
  DtlOutputPercentageVal: number;
  DtlLampOff: LegacyAny;
  DtlLampOffMin: LegacyAny;
  DtlLampOffMax: LegacyAny;
  DtlLampOffVal: LegacyAny;
  DtlEnabledval: LegacyAny;
  dtlDefaultColor: boolean;
  inputError: LegacyAny = [];
  DtlDimStopOption;
  DtlOutputPercentageOption;
  DtlLampOffOption;
  dtldisbaled: LegacyAny;
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  DtlLampOffDisabledVal: boolean;
  originalDtlLampOffDisabledVal: boolean;
  DtlLampOffDisbaled: LegacyAny;
  dtlCreatFile: boolean;
  isEdited: LegacyAny;
  isInitialLoad: boolean = true;
  isInitComplete: boolean = false;
  dtldDataSub: Subscription;
  isExternalRset: LegacyAny;


  DtlDimStartDisplayValue: LegacyAny;
  DtlDimStopDisplayValue: LegacyAny;
  DtlLampOffDisplayValue: LegacyAny;
  DtlOutputPercentageDisplayValue: LegacyAny;


  private dtlDimStartInputSubject = new Subject<string>();
  private dtlDimStopInputSubject = new Subject<string>();
  private dtlLampOffInputSubject = new Subject<string>();
  private dtlOutputPercentageInputSubject = new Subject<string>();
  constructor(
    private readonly ref: ChangeDetectorRef, private appState: AppStateService,
    private readonly misc: MiscFeatureStateService,
    private readonly featureDefaults: FeatureDefaultsStateService,
    private readonly aloAoc: AloAocStateService
  ) {
    super();
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const touchDimObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, touchDimObj);
  }
  ngOnInit() {
    this.isEdited = false;
    this.setupSubscriptions();

    if (!this.field || !this.field.properties || !this.field.requiredProperties) {
      this.initializeSafeDefaults();
      return;
    }

    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.misc.dtlInputError(false);

    const minMax = this.initializeSliderProperties();
    this.misc.sendMinMaxValues(minMax);

    this.loadConfigurationData();

    // Synchronous check like ALO  broadcast default color while isInitialDeviceRead is still true
    // so the parent won't auto-check DTL checkbox on page refresh
    this.checkdfault();
    this.misc.dtlEditedVal(this.dtlDefaultColor);

    setTimeout(() => {
      this.sendDtldata(this.ngModelval);
      this.isEdited = true;
      this.isInitialLoad = false;
      this.isInitComplete = true;
    }, 2000);

    this.DtlDimStartDisplayValue = this.DtlDimStartVal;
    this.DtlDimStopDisplayValue = this.DtlDimStopVal;
    this.DtlLampOffDisplayValue = this.DtlLampOffVal;
    this.DtlOutputPercentageDisplayValue = this.DtlOutputPercentageVal;

    this.setupInputSubjects();
  }

  private initializeSafeDefaults() {
    this.DtlDimStartOption = { floor: 0, ceil: 100 };
    this.DtlDimStopOption = { floor: 0, ceil: 100 };
    this.DtlLampOffOption = { floor: 0, ceil: 100 };
    this.DtlOutputPercentageOption = { floor: 0, ceil: 100 };
  }

  private setupSubscriptions() {
    this.dtldDataSub = this.featureDefaults.getdtlDefaultColor.subscribe((response) => {
      if (response) {
        this.dtlDefaultColor = true;
        this.resetDefaultDtl();
      }
    });
    this.dtldDataSub = this.misc.getDtldData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.DtlDimStartVal = data["DtlDimStartVal"];
        this.DtlDimStopVal = data["DtlDimStopVal"];
        this.DtlOutputPercentageVal = data["DtlOutputPercentageVal"];
        if (data["DtlLampOffVal"]) {
          this.DtlLampOffVal = data["DtlLampOffVal"];
        }
        this.checkdfault();
        this.checkInvalidValues();
        this.isInitialLoad = false;
      }
    });
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
  }

  private initializeSliderProperties(): LegacyAny[] {
    const minMax = [];
    this.DtlDimStart = this.properties.DtlDimStart;
    this.DtlOutputPercentage = this.properties.DtlOutputPercentage;
    this.DtlDimStop = this.properties.DtlDimStop;
    this.DtlDimStartMin = this.DtlDimStart.minimum;
    this.DtlDimStopMin = this.DtlDimStart.minimum;
    this.DtlLampOffMin = this.DtlDimStart.minimum;

    if (this.properties.DtlLampOff && this.properties.DtlLampOff.const === undefined) {
      this.DtlDimStartMax = this.DtlDimStart.maximum;
      this.DtlDimStopMax = this.DtlDimStop.maximum;
      this.field.anyOf.forEach((element) => {
        if (element.properties.DtlLampOff.maximum) {
          this.DtlLampOffMax = element.properties.DtlLampOff.maximum;
        }
      });
    } else {
      this.DtlDimStopMax = this.DtlDimStop.maximum;
      this.DtlDimStartMax = this.DtlDimStart.maximum;
    }

    this.ngModelval["DtlDimStartVal"] = this.DtlDimStartVal = this.DtlDimStart.default;
    this.DtlDimStartOption = { floor: this.DtlDimStartMin, ceil: this.DtlDimStartMax };
    minMax.push({ dtlStart: this.DtlDimStartOption });

    this.DtlOutputPercentageMin = this.DtlOutputPercentage.minimum;
    this.DtlOutputPercentageMax = this.DtlOutputPercentage.maximum;
    this.ngModelval["DtlOutputPercentageVal"] = this.DtlOutputPercentageVal = this.DtlOutputPercentage.default;
    this.DtlOutputPercentageOption = { floor: this.DtlOutputPercentageMin, ceil: this.DtlOutputPercentageMax };
    minMax.push({ dtlPercentage: this.DtlOutputPercentageOption });

    if (this.properties.DtlDimStop && this.properties.DtlDimStop.const === undefined) {
      this.ngModelval["DtlDimStopVal"] = this.DtlDimStopVal = this.DtlDimStop.default;
      this.DtlDimStopOption = { floor: this.DtlDimStopMin, ceil: this.DtlDimStopMax };
      minMax.push({ dtlStop: this.DtlDimStopOption });
    }

    if (this.properties.DtlLampOff && this.properties.DtlLampOff.const === undefined) {
      this.initializeLampOffProperties(minMax);
    }

    if (this.properties["DtlEnabled"] && this.column.includes("DtlEnabled")) {
      this.DtlEnabledval = this.properties["DtlEnabled"].default;
      this.ngModelval["DtlEnabled"] = this.properties["DtlEnabled"].default;
      this.dtldisbaled = this.properties["DtlEnabled"].default === false;
    }

    return minMax;
  }

  private initializeLampOffProperties(minMax: LegacyAny[]) {
    this.DtlLampOff = this.properties.DtlLampOff;
    if (this.properties.DtlLampOff["$interSchemaPropertyDependency"] !== undefined) {
      const maxLampOff = this.field.anyOf[0].properties.DtlLampOff.maximum;
      const constLampOff = this.field.anyOf[1].properties.DtlLampOff.const;
      const defaultLampOff = this.DtlLampOff.default;
      if (defaultLampOff < constLampOff) {
        this.ngModelval["DtlLampOffVal"] = this.DtlLampOffVal = this.DtlLampOff.default;
        this.originalDtlLampOffDisabledVal =
          this.DtlLampOffDisabledVal =
          this.ngModelval["DtlLampOffDisabled"] =
            false;
        this.DtlLampOffDisbaled = false;
      }
      if (defaultLampOff === constLampOff && maxLampOff < defaultLampOff) {
        this.ngModelval["DtlLampOffVal"] = this.DtlLampOffVal = maxLampOff;
        this.originalDtlLampOffDisabledVal =
          this.DtlLampOffDisabledVal =
          this.ngModelval["DtlLampOffDisabled"] =
            true;
        this.DtlLampOffDisbaled = true;
      }
    } else {
      this.ngModelval["DtlLampOffVal"] = this.DtlLampOffVal = this.DtlLampOff.default;
      this.originalDtlLampOffDisabledVal =
        this.DtlLampOffDisabledVal =
        this.ngModelval["DtlLampOffDisabled"] =
          false;
      this.DtlLampOffDisbaled = false;
    }
    this.DtlLampOffOption = {
      floor: this.DtlLampOffMin,
      ceil: this.DtlLampOffMax,
      step: 1,
      minLimit: this.ngModelval["DtlDimStopVal"] + 2,
      maxLimit: this.DtlLampOffMax,
    };
    minMax.push({ dtlLampOff: this.DtlLampOffOption });
    this.DtlDimStopOption = {
      floor: this.DtlDimStartMin,
      ceil: this.DtlDimStopMax,
      step: 1,
      minLimit: this.ngModelval["DtlDimStartVal"] + 5,
      maxLimit: this.DtlLampOffMax - 2,
    };
    this.DtlDimStartOption = {
      floor: this.DtlDimStartMin,
      ceil: this.DtlDimStartMax,
    };
    this.dimStartSlideValuechange(this.ngModelval["DtlDimStartVal"]);
  }

  private loadConfigurationData() {
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    const isConfigEdited = this.applyUnselectedFeatureConfig(unSelectedFeat);

    if (!isConfigEdited) {
      this.applyFileResponseConfig();
    }
  }

  private applyUnselectedFeatureConfig(unSelectedFeat: LegacyAny[]): boolean {
    if (!unSelectedFeat) {
      return false;
    }

    let isConfigEdited = false;
    let featIndex = 0;
    unSelectedFeat.forEach((element) => {
      if (
        element != null &&
        element["featureName"] != null &&
        element["featureName"].toString().toUpperCase() === "DTL"
      ) {
        isConfigEdited = true;
        const DTL: LegacyAny = element["featureParameters"][0];
        this.addDTLLoadedFeatureReadValues(DTL);
        unSelectedFeat.splice(featIndex, 1);
        this.appState.setUnSelectedFeatConfig(unSelectedFeat);
      } else {
        featIndex++;
      }
    });
    return isConfigEdited;
  }

  private applyFileResponseConfig()  {
    // Use centralized method to get feature data
    // Try different case variations for backward compatibility
    const dtlData = this.appState.getFeatureData('DTL') ||
                    this.appState.getFeatureData('Dtl') ||
                    this.appState.getFeatureData('dtl');

    if (dtlData) {
      this.addDTLLoadedFeatureReadValues(dtlData);
    }
  }

  private setupInputSubjects() {
    this.dtlDimStartInputSubject
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe((value) => {
        this.validateAndUpdateField(value, 'DtlDimStart');
      });

    this.dtlDimStopInputSubject
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe((value) => {
        this.validateAndUpdateField(value, 'DtlDimStop');
      });

    this.dtlLampOffInputSubject
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe((value) => {
        this.validateAndUpdateField(value, 'DtlLampOff');
      });

    this.dtlOutputPercentageInputSubject
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe((value) => {
        this.validateAndUpdateField(value, 'DtlOutputPercentage');
      });
  }


  onFieldInput(value: string, fieldName: string) {

    if (fieldName === 'DtlDimStart') {
      this.DtlDimStartDisplayValue = value;
      this.dtlDimStartInputSubject.next(value);
    } else if (fieldName === 'DtlDimStop') {
      this.DtlDimStopDisplayValue = value;
      this.dtlDimStopInputSubject.next(value);
    } else if (fieldName === 'DtlLampOff') {
      this.DtlLampOffDisplayValue = value;
      this.dtlLampOffInputSubject.next(value);
    } else if (fieldName === 'DtlOutputPercentage') {
      this.DtlOutputPercentageDisplayValue = value;
      this.dtlOutputPercentageInputSubject.next(value);
    }

    this.ref.detectChanges();
  }


  onFieldBlur(fieldName: string) {
    let value: string;
    if (fieldName === 'DtlDimStart') {
      value = this.DtlDimStartDisplayValue;
    } else if (fieldName === 'DtlDimStop') {
      value = this.DtlDimStopDisplayValue;
    } else if (fieldName === 'DtlLampOff') {
      value = this.DtlLampOffDisplayValue;
    } else if (fieldName === 'DtlOutputPercentage') {
      value = this.DtlOutputPercentageDisplayValue;
    }
    this.validateAndUpdateField(value, fieldName);
  }


  validateAndUpdateField(value: string, colName: string) {
    let numValue = parseFloat(value);


    if (isNaN(numValue) || value === '' || value === null || value === undefined) {
      this.inputError[colName] = true;
      this.dtlCreatFile = true;

      if (colName === 'DtlDimStart') {
        this.DtlDimStartDisplayValue = value;
        this.ngModelval['DtlDimStartVal'] = this.DtlDimStartMin;
        this.DtlDimStartVal = this.DtlDimStartMin;
      } else if (colName === 'DtlDimStop') {
        this.DtlDimStopDisplayValue = value;
        this.ngModelval['DtlDimStopVal'] = this.DtlDimStopMin;
        this.DtlDimStopVal = this.DtlDimStopMin;
      } else if (colName === 'DtlLampOff') {
        this.DtlLampOffDisplayValue = value;
        this.ngModelval['DtlLampOffVal'] = this.DtlLampOffMin;
        this.DtlLampOffVal = this.DtlLampOffMin;
      } else if (colName === 'DtlOutputPercentage') {
        this.DtlOutputPercentageDisplayValue = value;
        this.ngModelval['DtlOutputPercentageVal'] = this.DtlOutputPercentageMin;
        this.DtlOutputPercentageVal = this.DtlOutputPercentageMin;
      }

      this.misc.dtlInputError(this.dtlCreatFile);
      this.dtlDefaultColor = false;
      if (this.isInitComplete) {
        this.misc.dtlEditedVal(this.dtlDefaultColor);
      }
      this.ref.detectChanges();
      return;
    }

    numValue = parseInt(value);
    this.dtlDefaultColor = false;
    this.inputError[colName] = false;
    this.dtlCreatFile = false;

    if (colName === 'DtlDimStart') {

      if (numValue < this.DtlDimStartMin || numValue > this.DtlDimStartMax) {

        this.inputError[colName] = true;
        this.DtlDimStartDisplayValue = value;


        let clampedValue;
        if (numValue < this.DtlDimStartMin) {
          clampedValue = this.DtlDimStartMin;
        } else if (numValue > this.DtlDimStartMax) {
          clampedValue = this.DtlDimStartMax;
        }
        this.ngModelval['DtlDimStartVal'] = clampedValue;
        this.DtlDimStartVal = clampedValue;
      } else {

        this.DtlDimStartVal = this.ngModelval['DtlDimStartVal'] = numValue;
        this.DtlDimStartDisplayValue = numValue;
        this.inputError[colName] = false;


        if (this.DtlLampOff) {
          this.DtlDimStopOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlDimStopMax,
            step: 1,
            minLimit: parseInt(this.ngModelval['DtlDimStartVal']) + 5,
            maxLimit: parseInt(this.DtlLampOffMax) - 2,
          };
        } else {
          this.DtlDimStopOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlDimStopMax,
            step: 1,
            minLimit: parseInt(this.ngModelval['DtlDimStartVal']) + 5,
            maxLimit: this.DtlDimStopMax,
          };
        }


        if (numValue + 5 > this.ngModelval['DtlDimStopVal']) {
          this.inputError[colName] = true;
        }
      }
    } else if (colName === 'DtlDimStop') {
      if (numValue < this.DtlDimStopMin || numValue > this.DtlDimStopMax ||
          numValue < parseInt(this.ngModelval['DtlDimStartVal']) + 5) {

        this.inputError[colName] = true;
        this.DtlDimStopDisplayValue = value;


        let clampedValue;
        const effectiveMin = Math.max(this.DtlDimStopMin, parseInt(this.ngModelval['DtlDimStartVal']) + 5);
        if (numValue < effectiveMin) {
          clampedValue = effectiveMin;
        } else if (numValue > this.DtlDimStopMax) {
          clampedValue = this.DtlDimStopMax;
        }
        this.ngModelval['DtlDimStopVal'] = clampedValue;
        this.DtlDimStopVal = clampedValue;
      } else {

        this.ngModelval['DtlDimStopVal'] = numValue;
        this.DtlDimStopVal = numValue;
        this.DtlDimStopDisplayValue = numValue;
        this.inputError[colName] = false;
        this.dtlCreatFile = false;

        if (this.DtlLampOff) {
          this.DtlLampOffOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlLampOffMax,
            step: 1,
            minLimit: parseInt(this.ngModelval['DtlDimStopVal']) + 2,
            maxLimit: this.DtlLampOffMax,
          };
          if (
            this.ngModelval['DtlLampOffDisabled'] !== true &&
            numValue + 2 > this.ngModelval['DtlLampOffVal']
          ) {
            this.inputError[colName] = true;
          }
        }
      }
    } else if (colName === 'DtlLampOff') {
      if (numValue > this.DtlLampOffMax || numValue < parseInt(this.ngModelval['DtlDimStopVal']) + 2) {

        this.inputError[colName] = true;
        this.DtlLampOffDisplayValue = value;


        let clampedValue;
        const effectiveMin = parseInt(this.ngModelval['DtlDimStopVal']) + 2;
        if (numValue < effectiveMin) {
          clampedValue = numValue;
          this.DtlLampOffOption = {
            floor: this.DtlLampOffMin,
            ceil: this.DtlLampOffMax,
            step: 1,
            minLimit: this.DtlLampOffMin,
            maxLimit: this.DtlLampOffMax,
          };
        } else if (numValue > this.DtlLampOffMax) {
          clampedValue = this.DtlLampOffMax;
        }
        this.ngModelval['DtlLampOffVal'] = clampedValue;
        this.DtlLampOffVal = clampedValue;
      } else {

        this.ngModelval['DtlLampOffVal'] = numValue;
        this.DtlLampOffVal = numValue;
        this.DtlLampOffDisplayValue = numValue;
        this.inputError[colName] = false;
        this.DtlLampOffOption = {
          floor: this.DtlLampOffMin,
          ceil: this.DtlLampOffMax,
          step: 1,
          minLimit: parseInt(this.ngModelval['DtlDimStopVal']) + 2,
          maxLimit: this.DtlLampOffMax,
        };
      }
    } else if (colName === 'DtlOutputPercentage') {

      if (numValue < this.DtlOutputPercentageMin || numValue > this.DtlOutputPercentageMax) {

        this.inputError[colName] = true;
        this.DtlOutputPercentageDisplayValue = value;


        let clampedValue;
        if (numValue < this.DtlOutputPercentageMin) {
          clampedValue = this.DtlOutputPercentageMin;
        } else if (numValue > this.DtlOutputPercentageMax) {
          clampedValue = this.DtlOutputPercentageMax;
        }
        this.ngModelval['DtlOutputPercentageVal'] = clampedValue;
        this.DtlOutputPercentageVal = clampedValue;

        this.DtlOutputPercentageOption = {
          floor: this.DtlOutputPercentage.minimum,
          ceil: this.DtlOutputPercentageMax,
        };
      } else {

        this.DtlOutputPercentageVal = numValue;
        this.ngModelval['DtlOutputPercentageVal'] = numValue;
        this.DtlOutputPercentageDisplayValue = numValue;
        this.inputError[colName] = false;

        this.DtlOutputPercentageOption = {
          floor: this.DtlOutputPercentageMin,
          ceil: this.DtlOutputPercentageMax,
        };
      }
    }

    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.dtlCreatFile = true;
      }
    }
    this.checkInvalidValues();
    if (this.isInitComplete) {
      this.misc.dtlEditedVal(this.dtlDefaultColor);
    }
    this.misc.dtlInputError(this.dtlCreatFile);
    this.sendDtldata(this.ngModelval);
    this.ref.detectChanges();
  }

  sendDtldata(val) {
    this.misc.sendDtldata(val);
    if (this.isEdited) {
      this.setConfigurationData(val, "DTL");
    }
  }

  addDTLLoadedFeatureReadValues(Dtl: LegacyAny) {
    this.dtldisbaled = false;
    const DtlObj = Dtl;
    const keys = Object.keys(DtlObj);
    const values = Object.values(DtlObj);
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    if (this.column.includes("DtlEnabled")) {
      this.ngModelval["DtlEnabled"] = this.DtlEnabledval = result["DtlEnabled"] != null
        ? result["DtlEnabled"]
        : this.field.anyOf[0].properties.DtlEnabled.const;
      this.dtldisbaled = !this.DtlEnabledval;
    }
    if (
      result["DtlDimStopVal"] != undefined &&
      this.column.includes("DtlDimStop")
    ) {
      this.ngModelval["DtlDimStopVal"] =
        this.ngModelval["DtlDimStop"] =
        this.DtlDimStopVal =
          result["DtlDimStopVal"];
      this.DtlDimStopDisplayValue = result["DtlDimStopVal"];
    } else if (
      result["DtlDimStop"] != undefined &&
      this.column.includes("DtlDimStop")
    ) {
      this.ngModelval["DtlDimStopVal"] =
        this.ngModelval["DtlDimStop"] =
        this.DtlDimStopVal =
          result["DtlDimStop"];
      this.DtlDimStopDisplayValue = result["DtlDimStop"];
    }
    if (
      result["DtlDimStartVal"] != undefined &&
      this.column.includes("DtlDimStart")
    ) {
      this.ngModelval["DtlDimStartVal"] =
        this.ngModelval["DtlDimStart"] =
        this.DtlDimStartVal =
          result["DtlDimStartVal"];
      this.DtlDimStartDisplayValue = result["DtlDimStartVal"];
    } else if (
      result["DtlDimStart"] != undefined &&
      this.column.includes("DtlDimStart")
    ) {
      this.ngModelval["DtlDimStartVal"] =
        this.ngModelval["DtlDimStart"] =
        this.DtlDimStartVal =
          result["DtlDimStart"];
      this.DtlDimStartDisplayValue = result["DtlDimStart"];
    }
    if (
      result["DtlOutputPercentageVal"] != undefined &&
      this.column.includes("DtlOutputPercentage")
    ) {
      this.ngModelval["DtlOutputPercentageVal"] =
        this.ngModelval["DtlOutputPercentage"] =
        this.DtlOutputPercentageVal =
          result["DtlOutputPercentageVal"];
      this.DtlOutputPercentageDisplayValue = result["DtlOutputPercentageVal"];
    } else if (
      result["DtlOutputPercentage"] != undefined &&
      this.column.includes("DtlOutputPercentage")
    ) {
      this.ngModelval["DtlOutputPercentageVal"] =
        this.ngModelval["DtlOutputPercentage"] =
        this.DtlOutputPercentageVal =
          result["DtlOutputPercentage"];
      this.DtlOutputPercentageDisplayValue = result["DtlOutputPercentage"];
    }
    if (
      result["DtlLampOffVal"] != undefined &&
      this.column.includes("DtlLampOff")
    ) {
      this.ngModelval["DtlLampOffVal"] = this.ngModelval["DtlLampOff"] =
        result["DtlLampOffVal"];
      this.DtlLampOffVal = result["DtlLampOffVal"];
      this.DtlLampOffDisplayValue = result["DtlLampOffVal"];
    } else if (
      result["DtlLampOff"] != undefined &&
      this.column.includes("DtlLampOff")
    ) {
      if (result["DtlLampOff"] === 200) {
        // this.ngModelval["DtlLampOffVal"] = this.ngModelval["DtlLampOff"] =
        //   this.properties.DtlLampOff.default;
        if (
          this.properties.DtlLampOff.default ===
          this.field.anyOf[1].properties.DtlLampOff.const
        ) {
          this.DtlLampOffVal =
            this.ngModelval["DtlLampOffVal"] =
            this.ngModelval["DtlLampOff"] =
              this.field.anyOf[0].properties.DtlLampOff.maximum;
          this.DtlLampOffDisplayValue = this.field.anyOf[0].properties.DtlLampOff.maximum;
        } else {
          this.DtlLampOffVal =
            this.ngModelval["DtlLampOffVal"] =
            this.ngModelval["DtlLampOff"] =
              this.properties.DtlLampOff.default;
          this.DtlLampOffDisplayValue = this.properties.DtlLampOff.default;
        }
        this.DtlLampOffDisabledVal =
          this.ngModelval["DtlLampOffDisabled"] =
          result["DtlLampOffDisabled"] =
            true;
      } else {
        this.ngModelval["DtlLampOffVal"] = this.ngModelval["DtlLampOff"] =
          result["DtlLampOff"];
        this.DtlLampOffVal = result["DtlLampOff"];
        this.DtlLampOffDisplayValue = result["DtlLampOff"];
      }
    }
    this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
      result["DtlLampOffDisabled"];
    this.DtlLampOffDisbaled = result["DtlLampOffDisabled"];
    if (
      result["DtlLampOffDisabled"] === undefined &&
      result["DtlLampOff"] === 200
    ) {
      this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] = true;
      this.DtlLampOffDisbaled = true;
      this.lampOffDisabled(this.DtlLampOffDisbaled);
    } else {
      this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
        result["DtlLampOffDisabled"];
      this.DtlLampOffDisbaled = result["DtlLampOffDisabled"];
      if (result["DtlLampOffDisabled"] === undefined) {
        this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
          false;
        this.DtlLampOffDisbaled = false;
        this.lampOffDisabled(false);
      }
    }
    this.checkdfault();
    const ngModelkeys = Object.keys(this.ngModelval);
    const ngModelvalues = Object.values(this.ngModelval);
    ngModelkeys.forEach((key, i) => {
      this.textValChanged(ngModelvalues[i], key);
    });
    this.sendDtldata(this.ngModelval);
  }
  rSetChanged(val) {
    for (let i = 0; i < this.column.length; i++) {
      const type = this.column[i];
      if (
        type === "DtlEnabled" &&
        this.ngModelval[type] !== this.properties[type]["default"]
      ) {
        this.dtlDefaultColor = false;
      }
    }
    this.dtldisbaled = !val;
    this.checkdfault();
    this.sendDtldata(this.ngModelval);
  }

  dimStartSlideValuechange(value) {
    if (value >= this.DtlDimStartMin && value <= this.DtlDimStartMax) {
      this.ngModelval["DtlDimStartVal"] = value;
      this.DtlDimStartDisplayValue = value;
      this.inputError["DtlDimStart"] = false;
      if (this.DtlLampOff) {
        this.DtlDimStopOption = {
          floor: this.DtlDimStartMin,
          ceil: this.DtlDimStopMax,
          step: 1,
          minLimit: this.ngModelval["DtlDimStartVal"] + 5,
          maxLimit: this.DtlLampOffMax - 2,
        };
      } else {
        this.DtlDimStopOption = {
          floor: this.DtlDimStartMin,
          ceil: this.DtlDimStopMax,
          step: 1,
          minLimit: this.ngModelval["DtlDimStartVal"] + 5,
          maxLimit: this.DtlDimStopMax,
        };
      }
      if (value + 5 >= this.ngModelval["DtlDimStopVal"]) {
        this.DtlDimStopVal = this.ngModelval["DtlDimStopVal"] = value + 5;
        this.dimStopSlideValuechange(this.ngModelval["DtlDimStopVal"]);
      }
      this.checkInvalidValues();
      this.sendDtldata(this.ngModelval);
    } else {
      this.inputError["DtlDimStart"] = true;
      this.dtlCreatFile = true;
    }
  }

  dimStopSlideValuechange(value) {
    if (
      parseInt(value) >= this.DtlDimStopMin &&
      parseInt(value) <= this.DtlDimStopMax &&
      parseInt(value) >= parseInt(this.ngModelval["DtlDimStartVal"]) + 5
    ) {
      this.ngModelval["DtlDimStopVal"] = parseInt(value);
      this.DtlDimStopDisplayValue = parseInt(value);
      this.inputError["DtlDimStop"] = false;
      if (this.DtlLampOff) {
        this.DtlLampOffOption = {
          floor: parseInt(this.DtlDimStartMin),
          ceil: parseInt(this.DtlLampOffMax),
          step: 1,
          minLimit: parseInt(this.ngModelval["DtlDimStopVal"]) + 2,
          maxLimit: parseInt(this.DtlLampOffMax),
        };
        if (
          this.ngModelval["DtlLampOffDisabled"] !== true &&
          parseInt(value) + 2 >= this.ngModelval["DtlLampOffVal"]
        ) {
          this.DtlLampOffSlideValuechange(parseInt(value) + 2);
        }
      }
      this.checkInvalidValues();
      this.sendDtldata(this.ngModelval);
    }
  }

  dtlStopsliderChangeMinLim(value) {}

  dtlShutDownsliderEvent() {}

  dtlStartsliderChangeMinLim(value) {}
  DtlLampOffSlideValuechange(value) {
    this.DtlLampOffVal = value;
    if (
      value >= this.DtlLampOffMin &&
      value <= this.DtlLampOffMax &&
      value >= parseInt(this.ngModelval["DtlDimStopVal"]) + 2
    ) {
      this.ngModelval["DtlLampOffVal"] = value;
      this.DtlLampOffDisplayValue = value;
      this.inputError["DtlLampOff"] = false;
    } else {
      this.ngModelval["DtlLampOffVal"] = value;
      this.DtlLampOffDisplayValue = value;
      this.inputError["DtlLampOff"] = true;
    }
    this.checkInvalidValues();
    this.sendDtldata(this.ngModelval);
  }

  DtlOutputPercentageSlideValuechange(value) {
    this.inputError["DtlOutputPercentage"] = false;
    if (
      value >= this.DtlOutputPercentageMin &&
      this.inputError["DtlOutputPercentage"] === false
    ) {
      this.ngModelval["DtlOutputPercentageVal"] = value;
      this.DtlOutputPercentageDisplayValue = value;
      // this.dtlStopminValcalculate();
      this.DtlOutputPercentageVal = value;
      this.sendDtldata(this.ngModelval);
      this.checkdfault();
      this.checkInvalidValues();
    } else if (
      value < this.DtlOutputPercentageMin ||
      value > this.DtlOutputPercentageMax
    ) {
      this.inputError["DtlOutputPercentage"] = true;
      this.ngModelval["DtlOutputPercentageVal"] = this.DtlOutputPercentageVal =
        value;
      this.DtlOutputPercentageDisplayValue = value;
      this.sendDtldata(this.ngModelval);
      this.checkdfault();
      this.checkInvalidValues();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  textValChanged(value, colName) {
    const emptyVal = value;
    // value = parseInt(value);
    // if (isNaN(value) || value.length === 0) {
    //   value = 0;
    // }
    this.dtlDefaultColor = false;
    this.inputError[colName] = false;
    this.dtlCreatFile = false;
    if (colName === "DtlDimStart" && this.column.includes("DtlDimStart")) {
      if (emptyVal === "") {
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
        this.ngModelval["DtlDimStartVal"] = emptyVal;
      }
      if (value < this.DtlDimStartMin || value > this.DtlDimStartMax) {
        this.ngModelval["DtlDimStartVal"] = value;
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
      } else {
        this.DtlDimStartVal = this.ngModelval["DtlDimStartVal"] = value;
        if (this.DtlLampOff) {
          this.DtlDimStopOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlDimStopMax,
            step: 1,
            minLimit: parseInt(this.ngModelval["DtlDimStartVal"]) + 5,
            maxLimit: parseInt(this.DtlLampOffMax) - 2,
          };
        } else {
          this.DtlDimStopOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlDimStopMax,
            step: 1,
            minLimit: parseInt(this.ngModelval["DtlDimStartVal"]) + 5,
            maxLimit: this.DtlDimStopMax,
          };
        }
        if (
          value >= this.ngModelval["DtlDimStopVal"] ||
          parseInt(value) + 5 >= this.ngModelval["DtlDimStopVal"]
        ) {
          this.ngModelval["DtlDimStopVal"] = parseInt(value) + 5;
          this.inputError["DtlLampOff"] = false;
          this.inputError["DtlDimStop"] = false;
          this.dimStopSlideValuechange(this.ngModelval["DtlDimStopVal"]);
          this.DtlLampOffSlideValuechange(this.ngModelval["DtlLampOffVal"]);
        }
      }
    } else if (colName === "DtlDimStop" && this.column.includes("DtlDimStop")) {
      // if (emptyVal === "") {
      //   this.inputError[colName] = true;
      //   this.dtlCreatFile = true;
      //   this.ngModelval["DtlDimStopVal"] = emptyVal;
      // }
      if (
        value < this.DtlDimStopMin ||
        value > this.DtlDimStopMax ||
        value < parseInt(this.ngModelval["DtlDimStartVal"]) + 5 ||
        emptyVal === ""
      ) {
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
        this.ngModelval["DtlDimStopVal"] = value;
      } else {
        this.ngModelval["DtlDimStopVal"] = value;
        this.DtlDimStopVal = value;
        this.inputError[colName] = false;
        this.dtlCreatFile = false;
        if (this.DtlLampOff) {
          this.DtlLampOffOption = {
            floor: this.DtlDimStartMin,
            ceil: this.DtlLampOffMax,
            step: 1,
            minLimit: parseInt(this.ngModelval["DtlDimStopVal"]) + 2,
            maxLimit: this.DtlLampOffMax,
          };
        }
      }
    } else if (colName === "DtlOutputPercentage") {
      if (Number.isNaN(value)) {
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
      }
      if (
        value < this.DtlOutputPercentageMin ||
        value > this.DtlOutputPercentageMax
      ) {
        this.inputError[colName] = true;
        this.DtlOutputPercentageOption = {
          floor: this.DtlOutputPercentage.minimum,
          ceil: this.DtlOutputPercentageMax,
        };
        this.ngModelval["DtlOutputPercentageVal"] =
          this.DtlOutputPercentageVal = value;
      } else {
        this.DtlOutputPercentageVal = value;
        this.ngModelval["DtlOutputPercentageVal"] = value;
        this.DtlOutputPercentageOption = {
          floor: this.DtlOutputPercentageMin,
          ceil: this.DtlOutputPercentageMax,
        };
      }
    } else if (colName === "DtlLampOff" && this.column.includes("DtlLampOff")) {
      if (emptyVal === "") {
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
        this.ngModelval["DtlLampOffVal"] = emptyVal;
      }
      if (
        value > this.DtlLampOffMax ||
        value < parseInt(this.ngModelval["DtlDimStopVal"]) + 2
      ) {
        this.inputError[colName] = true;
        this.dtlCreatFile = true;
        this.ngModelval["DtlLampOffVal"] = value;
      } else {
        this.ngModelval["DtlLampOffVal"] = value;
        this.DtlLampOffVal = value;
      }
    }
    this.checkdfault();

    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.dtlCreatFile = true;
      }
    }
    this.checkInvalidValues();
    if (this.isInitComplete) {
      this.misc.dtlEditedVal(this.dtlDefaultColor);
    }
    this.misc.dtlInputError(this.dtlCreatFile);
    this.sendDtldata(this.ngModelval);
  }

  sliderEvent(option?) {
    this.checkdfault();
  }

  checkInvalidValues() {
    this.dtlCreatFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type] && this.column.includes(type)) {
        this.dtlCreatFile = true;
      }
    }
    this.misc.dtlInputError(this.dtlCreatFile);
  }

  resetDefaultDtl() {
    this.dtlDefaultColor = true;
    if (this.column.includes("DtlEnabled") && this.properties["DtlEnabled"]) {
      if (this.properties["DtlEnabled"].default === false) {
        this.ngModelval["DtlEnabled"] = false;
        this.dtldisbaled = true;
      } else {
        this.ngModelval["DtlEnabled"] = true;
        this.dtldisbaled = false;
      }
    }
    if (this.column.includes("DtlLampOff") && this.properties.DtlLampOff) {
      if (
        this.properties.DtlLampOff["$interSchemaPropertyDependency"] !=
        undefined
      ) {
        const maxLampOff = this.field.anyOf[0].properties.DtlLampOff.maximum;
        const constLampOff = this.field.anyOf[1].properties.DtlLampOff.const;
        const defaultLampOff = this.DtlLampOff.default;
        if (defaultLampOff < constLampOff) {
          this.ngModelval["DtlLampOffVal"] =
            this.ngModelval["DtlLampOff"] =
            this.DtlLampOffVal =
              this.DtlLampOff.default;
          this.DtlLampOffDisplayValue = this.DtlLampOff.default;
          this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
            false;
          this.DtlLampOffDisbaled = false;
        }
        if (defaultLampOff === constLampOff && maxLampOff < defaultLampOff) {
          this.ngModelval["DtlLampOffVal"] =
            this.ngModelval["DtlLampOff"] =
            this.DtlLampOffVal =
              maxLampOff;
          this.DtlLampOffDisplayValue = maxLampOff;
          this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
            true;
          this.DtlLampOffDisbaled = true;
        }
      } else {
        this.ngModelval["DtlLampOffVal"] =
          this.ngModelval["DtlLampOff"] =
          this.DtlLampOffVal =
            this.properties.DtlLampOff.default
              ? this.properties.DtlLampOff.default
              : this.properties.DtlLampOff.const;
        this.DtlLampOffDisplayValue = this.properties.DtlLampOff.default
          ? this.properties.DtlLampOff.default
          : this.properties.DtlLampOff.const;
        this.DtlLampOffDisabledVal = this.ngModelval["DtlLampOffDisabled"] =
          false;
        this.DtlLampOffDisbaled = false;
      }

      this.DtlLampOffOption = {
        floor: this.DtlLampOffMin,
        ceil: this.DtlLampOffMax,
        step: 1,
        minLimit: this.ngModelval["DtlDimStopVal"] + 2,
        maxLimit: this.DtlLampOffMax,
      };
    }
    if (this.column.includes("DtlDimStop") && this.properties.DtlDimStop) {
      this.ngModelval["DtlDimStopVal"] =
        this.ngModelval["DtlDimStop"] =
        this.DtlDimStopVal =
          this.DtlDimStop.default;
      this.DtlDimStopDisplayValue = this.DtlDimStop.default;
    }
    if (
      this.column.includes("DtlOutputPercentage") &&
      this.properties.DtlOutputPercentage
    ) {
      this.ngModelval["DtlOutputPercentageVal"] =
        this.ngModelval["DtlOutputPercentage"] =
        this.DtlOutputPercentageVal =
          this.DtlOutputPercentage.default;
      this.DtlOutputPercentageDisplayValue = this.DtlOutputPercentage.default;
    }
    if (this.column.includes("DtlDimStart") && this.properties.DtlDimStart) {
      this.ngModelval["DtlDimStartVal"] =
        this.ngModelval["DtlDimStart"] =
        this.DtlDimStartVal =
          this.DtlDimStart.default;
      this.DtlDimStartDisplayValue = this.DtlDimStart.default;
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.misc.dtlInputError(false);
    this.dtlCreatFile = false;
    this.misc.dtlInputError(this.dtlCreatFile);
    this.sendDtldata(this.ngModelval);
    this.ref.markForCheck();
  }

  checkdfault() {
    let newtype;
    this.dtlDefaultColor = true;

    for (const type in this.inputError) {
      if (this.inputError[type] && this.column.includes(type)) {
        this.dtlDefaultColor = false;
        if (this.isInitComplete) {
          this.misc.dtlEditedVal(this.dtlDefaultColor);
        }
        return;
      }
    }

    const keys = Object.keys(this.ngModelval);
    const values = Object.values(this.ngModelval);
    let result = [];
    result = keys.map((key, i) => {
      return {
        key: key,
        value: values[i],
      };
    });
    if (this.properties != null) {
      for (let i = 0; i < result.length; i++) {
        if (result[i]["key"]) {
          newtype = result[i]["key"].replace("Val", "");
          const index = result.indexOf(newtype);
          if (index > -1) {
            result.splice(index, 0);
          }
          if (
            result[i]["key"] === "DtlLampOffVal" ||
            result[i]["key"] === "DtlLampOff"
          ) {
            let dtlLampOffDefaultTemp: number = 0;
            if (
              this.properties != null &&
              this.properties.DtlLampOff &&
              this.properties.DtlLampOff["$interSchemaPropertyDependency"] !=
                undefined
            ) {
              const maxLampOff =
                this.field.anyOf[0].properties.DtlLampOff.maximum;
              const constLampOff =
                this.field.anyOf[1].properties.DtlLampOff.const;
              const defaultLampOff = this.DtlLampOff.default;
              if (defaultLampOff < constLampOff) {
                dtlLampOffDefaultTemp = this.DtlLampOff.default;
              }
              if (
                defaultLampOff === constLampOff &&
                maxLampOff < defaultLampOff
              ) {
                dtlLampOffDefaultTemp = maxLampOff;
              }
              if (this.ngModelval["DtlLampOffDisabled"] === false) {
                dtlLampOffDefaultTemp = this.DtlLampOff.default;
              } else {
                dtlLampOffDefaultTemp = this.DtlLampOff.default - 1;
              }
              if (
                this.properties.DtlLampOff.default ===
                this.field.anyOf[1].properties.DtlLampOff.const
              ) {
                dtlLampOffDefaultTemp =
                  this.field.anyOf[0].properties.DtlLampOff.maximum;
              } else {
                dtlLampOffDefaultTemp = this.properties.DtlLampOff.default;
              }
              if (
                result[i]["value"] && dtlLampOffDefaultTemp
                 != null &&
                result[i]["value"] !== dtlLampOffDefaultTemp
              ) {
                this.dtlDefaultColor = false;
              }
            } else {
              // let dtlLampOffNoDep =
              //   this.properties != null &&
              //   this.properties !== "" &&
              //   this.properties.DtlLampOff &&
              //   this.properties.DtlLampOff.default
              //     ? this.properties.DtlLampOff.default
              //     : this.properties != null &&
              //       this.properties.DtlLampOff &&
              //       this.properties.DtlLampOff.const
              //     ? this.properties.DtlLampOff.const
              //     : null;
              let dtlLampOffNoDep;
              if (
                this.properties != null &&
                this.properties !== "" &&
                this.properties.DtlLampOff &&
                this.properties.DtlLampOff.default &&
                this.properties.DtlLampOff.default ===
                  this.field.anyOf[1].properties.DtlLampOff.const
              ) {
                dtlLampOffNoDep =
                  this.field.anyOf[0].properties.DtlLampOff.maximum;
              } else if (
                this.properties != null &&
                this.properties.DtlLampOff &&
                this.properties.DtlLampOff.const
              ) {
                dtlLampOffNoDep = this.properties.DtlLampOff.const;
              } else if (
                this.properties != null &&
                this.properties.DtlLampOff &&
                this.properties.DtlLampOff.default
              ) {
                dtlLampOffNoDep = this.properties.DtlLampOff.default;
              }
              if (
                dtlLampOffNoDep && result[i]["value"] != null &&
                result[i]["value"] !== dtlLampOffNoDep
              ) {
                this.dtlDefaultColor = false;
              }
            }
          } else {
            if (
              result[i]["value"] != null &&
              result[i]["key"] === "DtlEnabled" &&
              (result[i]["value"] === true || result[i]["value"] === false)
            ) {
              let dtlEnableDefaultVal;
              if (
                this.properties[result[i]["key"]] &&
                    this.properties[result[i]["key"]]["default"]
                 != null &&
                this.properties[result[i]["key"]]["default"] === false
              ) {
                dtlEnableDefaultVal = false;
              } else if (
                this.properties[result[i]["key"]] &&
                    this.properties[result[i]["key"]]["default"]
                 != null &&
                this.properties[result[i]["key"]]["default"] === true
              ) {
                dtlEnableDefaultVal = true;
              } else if (
                this.properties[result[i]["key"]] &&
                    this.properties[result[i]["key"]]["default"]
                 != null &&
                this.properties[result[i]["key"]]["const"] === false
              ) {
                dtlEnableDefaultVal = false;
              } else {
                dtlEnableDefaultVal = true;
              }
              if (
                dtlEnableDefaultVal != null && result[i]["value"] != null &&
                result[i]["value"] !== dtlEnableDefaultVal
              ) {
                this.dtlDefaultColor = false;
              }
            } else if (
              result[i]["key"] === "DtlDimStopVal" &&
              this.properties[newtype] &&
              this.properties[newtype]["default"]
            ) {
              const val = this.properties[newtype]["default"]
                ? this.properties[newtype]["default"]
                : this.properties[newtype]["const"];
              if (
                result[i]["value"] && val != null &&
                result[i]["value"] !== val
              ) {
                this.dtlDefaultColor = false;
              }
            } else if (
              result[i]["key"] === "DtlLampOffDisabled" &&
              result[i]["value"] !== (this.originalDtlLampOffDisabledVal ? true : false)
            ) {
              this.dtlDefaultColor = false;
            } else if (
              this.properties && result[i]["value"] != null &&
              this.properties !== "" &&
              result[i]["key"] !== "DtlDimStopVal" &&
              result[i]["key"] !== "DtlLampOffDisabled" &&
              result[i]["value"] !=
                (this.properties[newtype] != null &&
                this.properties[newtype]["default"]
                  ? this.properties[newtype]["default"]
                  : this.properties[newtype] &&
                    this.properties[newtype]["const"]
                  ? this.properties[newtype]["const"]
                  : null)
            ) {
              this.dtlDefaultColor = false;
            }
          }
        }
      }
    }
    if (this.isInitComplete) {
      this.misc.dtlEditedVal(this.dtlDefaultColor);
    }
  }

  dtlStopminValcalculate() {
    this.DtlDimStopMin = this.DtlDimStartVal + 5;
    if (this.DtlDimStopVal < this.DtlDimStopMin) {
      this.ngModelval["DtlDimStopVal"] = this.DtlDimStopVal =
        this.DtlDimStopMin;
    }
    this.DtlDimStopOption = {
      floor: this.DtlDimStopMin,
      ceil: this.DtlDimStopMax,
    };
    this.dtlLampOffpminValcalculate();
  }

  lampOffDisabled(value) {
    this.DtlLampOffDisbaled = value;
    this.checkdfault();
    this.sendDtldata(this.ngModelval);
  }

  dtlLampOffpminValcalculate() {
    this.DtlLampOffMin = this.DtlDimStopVal + 2;
    if (this.DtlLampOffVal < this.DtlLampOffMin) {
      this.ngModelval["DtlLampOffVal"] = this.DtlLampOffVal =
        this.DtlLampOffMin;
    }
    this.DtlLampOffOption = {
      floor: this.DtlLampOffMin,
      ceil: this.DtlLampOffMax,
    };
  }

  ngOnDestroy() {
    this.featureDefaults.setDtlDefaultColor("");
    this.ngModelval = [];
    this.misc.sendDtldata(null);
    //this.sendDtldata("");
    this.properties = "";
    if (this.dtldDataSub) {
      this.dtldDataSub.unsubscribe();
    }
  }
}
